import type { ComponentProps, ReactNode } from "react"
import { cn } from "../../lib"
import { Field, Label, Textarea } from "../ui"
import type { SparkColour } from "../../lib"
import FieldDescriptionOrError from "./FieldDescriptionOrError"

type Props = ComponentProps<typeof Textarea> & {
  label?: ReactNode
  error?: string | null
  helperText?: string
  spark?: SparkColour
}

export default function TextareaField({
  label,
  spark,
  error,
  helperText,
  name,
  required,
  className,
  ...props
}: Props) {
  return (
    <Field className={cn("flex flex-col gap-1.5", className)}>
      <div className="flex flex-col gap-1.5">
        {!!label && (
          <Label
            htmlFor={name}
            className={cn(required && "after:content-['*']")}
            spark={spark}
          >
            {label}
          </Label>
        )}
        <div className="relative grow">
          <Textarea id={name} name={name} {...props} />
        </div>
      </div>
      <FieldDescriptionOrError description={helperText} error={error} />
    </Field>
  )
}
